import { pipe, catchError } from 'overmind';

import type { Context } from '@/overmind';
import { getRequestAborter } from '@/overmind/effects/requestAborter';
import { UnexpectedStateError, AbortError } from '@/overmind/errors';

const { switchToNewRequest, completeRequestOperator } =
  getRequestAborter('searchForFeatures');

export type SearchForFeaturesActionBody = {
  searchText: string;
};

export const searchForFeatures = pipe(
  async (
    { state, effects }: Context,
    { searchText }: SearchForFeaturesActionBody
  ) => {
    const abortController = switchToNewRequest();
    state.arcgis.featureSearch.send('TRIGGER_LOADING');
    const adapter = effects.arcgisMapAdapter.getAdapter();
    if (adapter) {
      return adapter.searchForFeatures(searchText, abortController);
    }

    throw new UnexpectedStateError();
  },
  ({ state }: Context, features) => {
    state.arcgis.featureSearch.send('FETCH_SUCCESS', features);
  },
  catchError(({ state }: Context, error) => {
    if (
      !(error instanceof UnexpectedStateError || error instanceof AbortError)
    ) {
      state.arcgis.featureSearch.send('FETCH_ERROR', error.message);
    }
  }),
  completeRequestOperator()
);

export const resetFeatureSearchState = pipe(async ({ state }: Context) => {
  state.arcgis.featureSearch.send('UNLOAD');
});
